import { useState } from 'react'

import { useSelector } from 'react-redux'
import { faPen } from '@fortawesome/pro-solid-svg-icons'

import StudentSearchBar from './StudentSearchBar'
import ConfirmFormFooter from '../../../Components/antd/Forms/ConfirmFormFooter'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const SearchStudentForm = ({ className, onCancel, onSearch, onConfirm }) => {
  const t = useSelector(selectTranslate)

  const [shouldDisplayFooter, setShouldDisplayFooter] = useState(false)

  const handleSubmit = (response, email) => {
    setShouldDisplayFooter(response.data.length === 0)

    onSearch(response, email)
  }

  const handleConfirm = () => {
    setShouldDisplayFooter(false)
    onConfirm()
  }

  return (
    <div className={className}>
      <StudentSearchBar className='flex-col' showNotFound onSubmit={handleSubmit} />

      {shouldDisplayFooter && (
        <>
          <br />
          <span className='ft-reg'>{t('search_student.create_student')}</span>

          <ConfirmFormFooter
            divider
            confirmTitle='modal.ok_button.create'
            confirmIcon={faPen}
            onCancel={onCancel}
            onConfirm={handleConfirm}
          />
        </>
      )}
    </div>
  )
}

export default SearchStudentForm
